import { FeatureName, isFeatureEnabled } from "@/config/features";

export function useFeature(name: FeatureName): boolean {
  return isFeatureEnabled(name);
}
